class DetailsModal {
  constructor(element) {
    this.element = element;
    this.detailsContainer = element.querySelector('.details-wrapper');
    this.summaryToggle = element.querySelector('.summary-toggle');
    this.modalContent = element.querySelector('.search-modal');
    
    // Ensure modal is hidden initially
    if (this.modalContent) {
      this.modalContent.style.display = 'none';
    }
    
    this.init();
  }

  init() {
    // Keyboard events
    if (this.detailsContainer) {
      this.detailsContainer.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.close();
        }
      });
    }
    
    // Toggle click
    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', (event) => {
        this.onSummaryClick(event);
      });
      
      // Handle Enter and Space keys on the toggle button
      this.summaryToggle.addEventListener('keydown', (event) => {
        if (event.code === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          this.onSummaryClick(event);
        }
      });
    }
    
    // Close button
    const closeButton = this.element.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.close();
      });
    }
  }

  isOpen() {
    return this.detailsContainer && this.detailsContainer.classList.contains('is-open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.isOpen()) {
      this.close();
    } else {
      this.open(event);
    }
  }

  onBodyClick(event) {
    if (!this.element.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event) {
    if (!this.detailsContainer || !this.modalContent) {
      return;
    }
    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    
    // Add open state
    this.detailsContainer.classList.add('is-open');
    this.detailsContainer.setAttribute('open', '');
    
    // Show modal with multiple methods to ensure visibility
    this.modalContent.style.display = 'block';
    this.modalContent.style.visibility = 'visible';
    this.modalContent.style.opacity = '1';
    this.modalContent.style.pointerEvents = 'auto';
    
    if (this.summaryToggle) {
      this.summaryToggle.setAttribute('aria-expanded', 'true');
    }
    
    // Small delay to ensure the click event doesn't immediately close
    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }, 100);
    
    document.body.classList.add('overflow-hidden');
    
    // Trap focus
    const focusElement = this.element.querySelector('input:not([type="hidden"])');
    if (focusElement && typeof trapFocus !== 'undefined') {
      setTimeout(() => {
        trapFocus(
          this.detailsContainer.querySelector('[tabindex="-1"]'),
          focusElement
        );
      }, 50);
    }
  }

  close(focusToggle = true) {
    if (!this.detailsContainer || !this.modalContent) {
      return;
    }
    
    // Remove trap focus
    if (typeof removeTrapFocus !== 'undefined') {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    }
    
    // Remove open state
    this.detailsContainer.classList.remove('is-open');
    this.detailsContainer.removeAttribute('open');
    
    // Hide modal
    this.modalContent.style.display = 'none';
    this.modalContent.style.visibility = 'hidden';
    this.modalContent.style.opacity = '0';
    this.modalContent.style.pointerEvents = 'none';
    
    if (this.summaryToggle) {
      this.summaryToggle.setAttribute('aria-expanded', 'false');
    }
    
    // Restore body scroll
    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
    document.body.classList.remove('overflow-hidden');
  }
}

// Initialize all search modals on page load
document.addEventListener('DOMContentLoaded', () => {
  const searchModals = document.querySelectorAll('.search-modal-wrapper');
  searchModals.forEach(modal => {
    new DetailsModal(modal);
  });
});

// For compatibility with existing code that might reference the custom element
if (typeof customElements !== 'undefined' && !customElements.get('details-modal')) {
  class DetailsModalElement extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      new DetailsModal(this);
    }
  }
  
  customElements.define('details-modal', DetailsModalElement);
}